import React from 'react';
import Button from '../../components/Button';
import Buttons from '../../components/Buttons';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import emailIcon from '../../icons/non-prefilled/16x16/email.svg';
import ExternalProfileButtons from './ExternalProfileButtons';

const USER_FRAGMENT = gql(`
  fragment UserProfileButtons_user on User {
    id
    email
    importedFrom
    ...ExternalProfileButtons_user
  }
`);

interface UserProfileButtonsProps {
  user: DocumentType<typeof USER_FRAGMENT>;
  size?: 'small' | 'regular';
}

const UserProfileButtons = ({
  user,
  size = 'regular',
}: UserProfileButtonsProps) => {
  const { email, importedFrom } = user;

  if (importedFrom) {
    return null;
  }

  return (
    <Buttons>
      {email && (
        <Button
          variant="secondary"
          size={size}
          to={`mailto:${email}`}
          newTab
          icon={emailIcon}
        >
          Email
        </Button>
      )}
      <ExternalProfileButtons user={user} size={size} />
    </Buttons>
  );
};

export default UserProfileButtons;
